// extracted by mini-css-extract-plugin
module.exports = {"label":"DragNDropField_label__1Ip-Z","file":"DragNDropField_file__1l_pM"};